// TODO Uncomment this after developing
const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes`;

// Use this API_URL if you reach the limit
// const API_URL = `https://api.allorigins.win/raw?url=https://forkify-api.herokuapp.com/api/v2/recipes`;
const TIMEOUT_SECONDS = 10;
const RES_PER_PAGE = 10;
const API_KEY = '0cc600ab-4a3b-401e-b421-6b15de015086';
const CLOSE_WINDOW_SEC = 2.5;

export { API_URL, TIMEOUT_SECONDS, RES_PER_PAGE, API_KEY, CLOSE_WINDOW_SEC };
